import React from 'react';
import PropTypes from 'prop-types';
import variables from '../variables';

const WarningIcon = ({
  height = 40,
  color = variables.colors.white,
  ...props
}) => {
  return (
    <svg height={height} viewBox="0 0 40 40" fill="none" {...props}>
      <path
        d="M16.9727 2.05458C18.22 -0.440047 21.78 -0.440047 23.0273 2.05458L39.5509 35.1017C40.6761 37.3522 39.0396 40 36.5236 40H3.47642C0.960358 40 -0.676087 37.3522 0.449131 35.1017L16.9727 2.05458Z"
        fill={color}
      />
      <path
        d="M22.2413 24.293C22.2159 25.4875 21.1863 26.4433 19.9248 26.4433C18.6626 26.4433 17.6327 25.4864 17.6081 24.2911L17.206 13.634C17.1764 12.1876 18.4062 11 19.9336 11C21.4618 11 22.6921 12.189 22.6611 13.6362L22.2413 24.293Z"
        fill="white"
      />
      <circle cx="20" cy="32" r="3" fill="white" />
    </svg>
  );
};

WarningIcon.propTypes = {
  height: PropTypes.number,
  color: PropTypes.string,
};

export default WarningIcon;
